import styled from 'styled-components';

/*
 * Variantes (marca nueva):
 *  primary   → fondo marino, texto blanco; hover verde azulado
 *  secondary → borde y texto verde azulado; hover relleno verde azulado
 *  ghost     → borde neutro, texto secundario
 *  white     → para bloques marino: fondo blanco, texto marino; hover turquesa con texto marino
 *  success / danger → semánticos
 */
// variant / size / fullWidth son solo de estilo: no deben llegar al <button> del DOM
// (React avisa de "unknown prop" y deja atributos basura como fullwidth="true").
const STYLE_ONLY_PROPS = ['variant', 'size', 'fullWidth'];

export const StyledButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !STYLE_ONLY_PROPS.includes(prop),
})`
  background: ${props => {
    switch (props.variant) {
      case 'secondary':  return 'transparent';
      case 'ghost':      return 'transparent';
      case 'white':      return 'var(--white)';
      case 'danger':     return 'var(--danger)';
      case 'success':    return 'var(--success)';
      default:           return 'var(--primary)';
    }
  }};
  color: ${props => {
    switch (props.variant) {
      case 'secondary':  return 'var(--secondary)';
      case 'ghost':      return 'var(--text-secondary)';
      case 'white':      return 'var(--primary)';
      case 'success':    return 'var(--primary)';
      default:           return 'var(--text-on-primary)';
    }
  }};
  border: ${props => {
    switch (props.variant) {
      case 'secondary':  return '1.5px solid var(--secondary)';
      case 'ghost':      return '1.5px solid var(--border-medium)';
      default:           return '1.5px solid transparent';
    }
  }};
  padding: ${props => {
    switch (props.size) {
      case 'small':  return '8px 18px';
      case 'large':  return '16px 36px';
      default:       return '12px 28px';
    }
  }};
  border-radius: var(--radius-round);
  cursor: pointer;
  font-family: var(--font-brand);
  font-size: ${props => {
    switch (props.size) {
      case 'small':  return 'var(--text-sm)';
      case 'large':  return 'var(--text-lg)';
      default:       return 'var(--text-base)';
    }
  }};
  font-weight: 600;
  transition: all var(--transition-fast);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  opacity: ${props => props.disabled ? 0.5 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.variant === 'secondary' || props.variant === 'ghost'
      ? 'var(--shadow-sm)'
      : 'var(--shadow-primary)'};
    ${props => {
      switch (props.variant) {
        case 'secondary': return 'background: var(--secondary); color: var(--text-on-dark);';
        case 'ghost':     return 'border-color: var(--secondary); color: var(--secondary);';
        case 'white':     return 'background: var(--accent); color: var(--primary);';
        case 'danger':    return 'background: var(--danger-dark);';
        case 'success':   return 'background: var(--success-dark); color: var(--text-on-dark);';
        default:          return 'background: var(--secondary);';
      }
    }}
  }

  &:active {
    transform: translateY(0);
  }

`;
